import { createSelector } from "reselect";

import { AppState } from "../_root/rootReducer";

const getLoading = (state: AppState) => state.userLogin.loading;

const getResult  = (state: AppState) => state.userLogin.result;

const getError = (state: AppState) => state.userLogin.error;

export const getResultUserLoginSelector = createSelector(getResult, (result) => result);

export const getLoadingUserLoginSelector = createSelector(
  getLoading,
  (loading) => loading
);

export const getErrorUserLoginSelector = createSelector(getError, (error) => error);